import {ProductCategory} from "./product-category.model";

/**
 * Model grupujący drzewo kategorii produktów dla konkretnego gatunku zwierzęcia.
 * Pełni rolę najwyższego poziomu nawigacji w sklepie (tzw. "Root" dla drzewa kategorii).
 */
export class ProductCategoriesForSpecies {

  /** Gatunek zwierzęcia.
   * Jest to wartość tekstowa mapowana na słownik w systemie.
   */
  public species: string;

  /** Tablica głównych kategorii (oraz ich zagnieżdżonych podkategorii)
   * dostępnych wyłącznie dla tego konkretnego gatunku.
   * Wykorzystuje rekurencyjny model ProductCategory.
   */
  public categories: ProductCategory[];

}
